module.exports = __webpack_public_path__ + "img/sweden-endocrine-nutritional-metabolic-diseases-female.6a19fb1e.png";